export default ($) => {
  let teaserTabs = $('._teaserTabs');

  teaserTabs.each((index, tab) => {
    let _self         = $(tab);
    let tabs          = _self.find('.js-tab');
    let teasers       = _self.find('.js-teaser');
    let select        = _self.find('select');

    tabs.on('click', function () {
      let selectOptions = _self.find('.select-options');
      let _this = $(this);
      if (_this.hasClass('-active')) return;

      let dataTeaser = _this.data('teaser');
      selectOptions.find('li[rel="' + dataTeaser + '"]').click();
    });

    select.on('change', function () {
      let thisValue = $(this).val();

      tabs.removeClass('-active');
      teasers.removeClass('-active');

      _self.find('.js-tab[data-teaser="' + thisValue + '"]').addClass('-active');
      _self.find('.js-teaser[data-teaser="' + thisValue + '"]').addClass('-active');
    })
  });
}